import React from 'react';
import './css/Politica.css';
import './css/TextPage.css';

const PoliticaCookies: React.FC = () => {
  return (
    <div className="politica-container text-page">
      <h1>Política de Cookies</h1>
      <p>Utilizamos cookies para garantir o funcionamento adequado do site, melhorar sua experiência e analisar o tráfego.</p>

      <h2>1. O que são Cookies?</h2>
      <p>Cookies são pequenos arquivos de texto armazenados no seu dispositivo quando você visita um site.</p>

      <h2>2. Por que usamos Cookies?</h2>
      <ul>
        <li>Para lembrar suas preferências;</li>
        <li>Melhorar o desempenho do site;</li>
        <li>Entender como os usuários interagem com o conteúdo;</li>
        <li>Oferecer conteúdos personalizados.</li>
      </ul>

      <h2>3. Tipos de Cookies</h2>
      <ul>
        <li><strong>Essenciais:</strong> necessários para o funcionamento do site;</li>
        <li><strong>Desempenho:</strong> coletam dados de uso anonimamente;</li>
        <li><strong>Funcionais:</strong> lembram preferências do usuário;</li>
        <li><strong>Publicidade:</strong> utilizados para apresentar anúncios relevantes.</li>
      </ul>

      <h2>4. Como gerenciar cookies?</h2>
      <p>Você pode alterar suas configurações de cookies no navegador a qualquer momento ou limpar cookies armazenados.</p>

      <p>Última atualização: Abril de 2025</p>
    </div>
  );
};

export default PoliticaCookies;
